
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CaixaTemComponent } from './caixa-tem.component';
import { CaixaTemRoutingModule } from './caixa-tem-routing.module';
import { SwiperModule } from 'swiper/angular';

import { PlaylistModule } from 'src/app/components/playlist-videos/playlist.module';
import { CardModule } from 'src/app/components/card-component/card-component.module';
import { FaqComponentModule } from 'src/app/components/faq-componente/faq-componente.module';
import { RouterModule } from '@angular/router';


@NgModule({
    declarations: [
        CaixaTemComponent,
    ],
    imports: [
        CommonModule,
        CaixaTemRoutingModule,
        SwiperModule,
        LazyLoadImageModule,
        PlaylistModule,
        RouterModule,
        CardModule,
        FaqComponentModule
    ]
})
export class CaixaTemModule { }


